__turbopack_context__.v({
  "btn": "card-gallery-module__jIHIfq__btn",
  "gallery": "card-gallery-module__jIHIfq__gallery",
  "image": "card-gallery-module__jIHIfq__image",
  "imageWpr": "card-gallery-module__jIHIfq__imageWpr",
  "next": "card-gallery-module__jIHIfq__next",
  "prev": "card-gallery-module__jIHIfq__prev",
  "thumb": "card-gallery-module__jIHIfq__thumb",
  "thumbActive": "card-gallery-module__jIHIfq__thumbActive",
  "thumbs": "card-gallery-module__jIHIfq__thumbs",
  "viewport": "card-gallery-module__jIHIfq__viewport",
  "wrapper": "card-gallery-module__jIHIfq__wrapper",
});
